// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/browser-detection/browser-detection.component.scss
// module id = 256
// module chunks = 0